import { UserProxy, UserDocument, TaxRates, UserTaxType } from '@/api/types/user'
import { getActiveResources, getReadyDrives } from './selectors'

type Action = {
  title: string
  route: string
}

export type ModalInformation = {
  title: string
  text: string
  actions?: Array<Action>
}

export type AuthProvider = 'google.com' | 'password'

export const attemptNewWorkstationModal = (user: UserProxy): null | ModalInformation => {
  if (getActiveResources(user.workstations).length >= user.maxNumberOfWorkstations) {
    return {
      title: 'Computers limit reached',
      text: `You have reached the current limit of ${user.maxNumberOfWorkstations} computers on your account. If you need an additional one, please upgrade Your plan to Studio.`,
      actions: [
        {
          title: 'UPGRADE PLAN',
          route: '/select-plan',
        },
      ],
    }
  } else if (!billingInformationIsCorrect(user.profile)) {
    return {
      title: 'Missing payment method...',
      text: `Before you can get new computer you need to add a payment card through billing details in your account.`,
      actions: [
        {
          title: 'ADD CARD',
          route: '/account/billing',
        },
      ],
    }
  } else if (getReadyDrives(user.drives).length === 0) {
    return {
      title: 'Create a drive first...',
      text: `Before you can get new computer, you need to add a drive that will be attached to it.`,
    }
  }
  return null
}

export const attemptNewDriveModal = (user: UserProxy): null | ModalInformation => {
  if (getActiveResources(user.drives).length >= user.maxNumberOfDrives) {
    return {
      title: 'Drives limit reached',
      text: `You have reached the current limit of ${user.maxNumberOfDrives} drives on your account. If you need an additional one, please contact us on <a href="mailto:support@renderro.com">support@renderro.com</a>`,
    }
  } else if (!billingInformationIsCorrect(user.profile)) {
    return {
      title: 'Missing payment method...',
      text: `Before you can get new drive you need to add a payment card through billing details in your account.`,
      actions: [
        {
          title: 'ADD CARD',
          route: '/account/billing',
        },
      ],
    }
  }
  return null
}

/**
 * Helper - check if billing information is correct on a user profile
 * @param profile a user's profile to check
 * @returns a boolean indicating whether billing information is complete
 */
export const billingInformationIsCorrect = (profile: UserDocument | null): boolean => {
  const billing = profile?.billing
  return (
    Boolean(billing?.stripe_customer_identifier) &&
    Boolean(billing?.stripe_active_payment_method_identifier)
  )
}

const TAX_RATES: TaxRates = {
  individual: '23.00',
  business: '0.00',
}

/**
 * Helper - get tax rate for tax type in a formatted string
 *
 * Used as a interface to get a the rate, not risk modifying it
 * @param userTaxType a string representing type of tax
 * @returns a tax rate string
 */
export function getTaxRateString(userTaxType: UserTaxType): string {
  return TAX_RATES[userTaxType]
}
